import createModule from "../createModule"
import view from "./view"
import { Creators as DialogCreators } from "modules/dialog/model"
import { getUnmodeledDates } from "selectors/dates"
import { getMenuItems, getSelectedComparisonType } from "./selectors"
import { getDatesAdjusted } from "./selectors/dates"

export default createModule({
  view,
  externalProps: (state) => ({
    account: state.global.selected.account,
  }),
  required: ["account", "portfolioId"],
  mapStateToProps: (state, props) => ({
    selectedComparisonType: getSelectedComparisonType(state, props),
    datesAdjusted: getDatesAdjusted(state, props),
    unmodeledDates: getUnmodeledDates(state),
    menuItems: getMenuItems(state, props),
  }),
  actions: {
    openDialog: DialogCreators.open,
  },
})
